import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { OrderContextProvider } from './components/shared/OrderContext';
import store from './redux/store';
import { Provider } from 'react-redux';
import { StoreSiteProvider } from './components/shared/StoreDropdownContext';

const rootElement = document.getElementById('root');

// Ensure rootElement is not null
if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <OrderContextProvider>
      <StoreSiteProvider>
        <App />
      </StoreSiteProvider>
    </OrderContextProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();